var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cf-channel-pill",style:(_vm.pillStyle)},[_c('v-icon',{staticClass:"mr-1",attrs:{"x-small":"","color":_vm.brand.color}},[_vm._v(_vm._s(_vm.brand.icon))]),_c('span',{staticClass:"cf-channel-pill__label"},[_vm._v(_vm._s(_vm.displayName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }